import { render, staticRenderFns } from "./CustomSlider.vue?vue&type=template&id=0c4ec838&scoped=true"
import script from "./CustomSlider.vue?vue&type=script&lang=ts"
export * from "./CustomSlider.vue?vue&type=script&lang=ts"
import style0 from "./CustomSlider.vue?vue&type=style&index=0&id=0c4ec838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ec838",
  null
  
)

export default component.exports